import AxisConfiguration from "./axis_configuration"
import LayerConfiguration from "./layer_configuration"
import ChartOptions from "./chart_options"

export default class CartesianConfiguration {
    constructor(attributes) {
        this.x = attributes.x.map(axis => new AxisConfiguration(axis))
        this.y = attributes.y.map(axis => new AxisConfiguration(axis))
        this.layers = attributes.layers.map(layer => new LayerConfiguration(layer))
        this.options = new ChartOptions(attributes.options)
    }

    axisConfigs(axis) {
        return this[axis]
    }

    defaultAxisLabel(axis) {
        return this.axisConfigs(axis)[0]?.label
    }

    axisByLabel(axis, label) {
        return this.axisConfigs(axis).find(axisConfig => axisConfig.label === label)
    }
}
